var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"px-0 py-0",attrs:{"fluid":""}},[_c('v-row',{staticClass:"py-3",attrs:{"no-gutters":""}},_vm._l((_vm.unitsToEdit),function(unit,index){return _c('v-chip',{key:index,staticClass:"mr-2"},[_vm._v("\n      "+_vm._s(("Loja " + (unit.id_erp) + " - " + (unit.name)))+"\n    ")])}),1),_c('sortable-highlighted-offers',{attrs:{"type":_vm.type}}),_c('clickable-offers-table',{attrs:{"type":_vm.type}}),_c('mf-action-buttons',{staticClass:"mt-3",attrs:{"primary-button":{
      text: 'Salvar',
      action: _vm.confirm,
      isVisible: true,
      isLoading: _vm.loading,
    },"cancel-button":{
      text: 'Cancelar',
      action: _vm.cancel,
      isVisible: true,
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }